@if(!isOnline()){
<div class="__system_maintenance_prompt__">
    <div class="flex flex-col gap-3 justify-center items-center">
        <img [src]="offlineImgDataUrl" />
        <span class="font-semibold text-xl">You are Offline!</span>
        <span class="font-semibold text-xl text-neutral-400">No Internet connection found. Check your connection</span>
    </div>
</div>
} @else if (maintenanceMode()) {
<div class="__system_maintenance_prompt__">
    <div class="flex flex-col gap-3 justify-center items-center">
        <i class="pi pi-exclamation-triangle text-6xl text-yellow-500"></i>
        <span class="font-semibold text-xl">System Under Maintenance</span>
        <span class="font-semibold text-xl text-neutral-400">We are currently performing scheduled maintenance. Please
            check back later.</span>
    </div>
</div>
}